import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CustomInput from '@/components/CustomInput/CustomInput';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import loader from '../../assets/img/loader.svg';
import Button from '@/components/CustomButtons/Button';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import CardBody from '@/components/Card/CardBody';
import { API_BASE_URL } from '@/config';
import { useNavigate } from 'react-router-dom';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { getOrganizations } from '@/views/Organizations/Organizations.api';

export default function CreateMoovAccount() {
  const { t } = useTranslation();
  const [loaded, setLoaded] = useState(false);
  const [formInputs, setFormInputs] = useState({
    legalBusinessName: '',
    businessType: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateOrProvince: '',
    postalCode: '',
    email: '',
    phone: '',
    dateOfBirth: '',
    last4OfSSN: '',
    jobTitle: '',
    isOwner: false,
    ownershipPercentage: '',
    firstName: '',
    lastName: '',
    middleName: '',
    website: '',
    description: '',
    ein: '',
  });
  const [organizationId, setOrganizationId] = useState('');
  const [organizations, setOrganizations] = useState([]);

  const [message] = useState('');
  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormInputs((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const navigate = useNavigate();

  const onOrganizationIdChange = (e) => {
    setOrganizationId(e.target.value);
  };

  const CreateMoovAccount = async (e) => {
    e.preventDefault();
    setLoaded(true);
    const requestData = {
      ...formInputs,
      organizationId,
    };
    // eslint-disable-next-line no-unused-vars
    const id = (
      await axios.post(API_BASE_URL + '/createMoovAccount', requestData)
    ).data.id;
    setLoaded(false);
    navigate('/admin/MoovPage');
  };

  const cancelfrm = () => {
    navigate('/admin/MoovPage');
  };

  // Required information	Owner	Controller
  // Legal name	yes	yes
  // Personal address	yes	yes
  // Email or phone #	yes	yes
  // Date of birth	yes	yes
  // Last 4 of SSN	yes	yes
  // isController	not required	yes
  // Job title	not required	yes
  // isOwner	yes	not required
  // Ownership percentage	yes	not required

  // add a checkbox for isController

  useEffect(() => {
    getOrganizations().then((res) => {
      setOrganizations(res.data.organizations);
    });
  }, []);

  return (
    <div>
      <form onSubmit={CreateMoovAccount}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='primary'>
                <h4>{t('createMoovAccount.title')}</h4>
              </CardHeader>

              <CardBody>
                {loaded && (
                  <div className='loaders'>
                    <img src={loader} />
                  </div>
                )}

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t('createMoovAccount.fields.legalName')}
                      onChange={onInputChange}
                      value={formInputs.legalBusinessName}
                      name='legalBusinessName'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t('createMoovAccount.fields.ein')}
                      onChange={onInputChange}
                      value={formInputs.ein}
                      name='ein'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    {/* <CustomInput
                      type='text'
                      labelText='Business type'
                      onChange={onInputChange}
                      value={formInputs.businessType}
                      name='businessType'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    /> */}
                    {/* soleProprietorship, unincorporatedAssociation, trust, publicCorporation, privateCorporation, privateCorporation, llc, partnership, unincorporatedNonProfit, incorporatedNonProfit */}
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-tango'>
                          {t('createMoovAccount.fields.accountType')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-tango'
                          id='demo-simple-select'
                          value={formInputs.businessType}
                          onChange={onInputChange}
                          name='businessType'
                          className='full-width-elem'>
                          <MenuItem value='soleProprietorship'>
                            {t(
                              'createMoovAccount.businessTypes.soleProprietorship',
                            )}
                          </MenuItem>
                          <MenuItem value='unincorporatedAssociation'>
                            {t(
                              'createMoovAccount.businessTypes.unincorporatedAssociation',
                            )}
                          </MenuItem>
                          <MenuItem value='trust'>
                            {t('createMoovAccount.businessTypes.trust')}
                          </MenuItem>
                          <MenuItem value='publicCorporation'>
                            {t(
                              'createMoovAccount.businessTypes.publicCorporation',
                            )}
                          </MenuItem>
                          <MenuItem value='privateCorporation'>
                            {t(
                              'createMoovAccount.businessTypes.privateCorporation',
                            )}
                          </MenuItem>
                          <MenuItem value='llc'>
                            {t('createMoovAccount.businessTypes.llc')}
                          </MenuItem>
                          <MenuItem value='partnership'>
                            {t('createMoovAccount.businessTypes.partnership')}
                          </MenuItem>
                          <MenuItem value='unincorporatedNonProfit'>
                            {t(
                              'createMoovAccount.businessTypes.unincorporatedNonProfit',
                            )}
                          </MenuItem>
                          <MenuItem value='incorporatedNonProfit'>
                            {t(
                              'createMoovAccount.businessTypes.incorporatedNonProfit',
                            )}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  {/* <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText='First name'
                      onChange={onInputChange}
                      value={formInputs.firstName}
                      name='firstName'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem> */}
                  {/* <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText='Middle name'
                      onChange={onInputChange}
                      value={formInputs.middleName}
                      name='middleName'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText='Last name'
                      onChange={onInputChange}
                      value={formInputs.lastName}
                      name='lastName'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem> */}
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('createMoovAccount.fields.addressLine1')}
                      name='addressLine1'
                      onChange={onInputChange}
                      value={formInputs.addressLine1}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('createMoovAccount.fields.addressLine2')}
                      name='addressLine2'
                      onChange={onInputChange}
                      value={formInputs.addressLine2}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('createMoovAccount.fields.city')}
                      name='city'
                      onChange={onInputChange}
                      value={formInputs.city}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('createMoovAccount.fields.stateOrProvince')}
                      name='stateOrProvince'
                      onChange={onInputChange}
                      value={formInputs.stateOrProvince}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('createMoovAccount.fields.postalCode')}
                      name='postalCode'
                      onChange={onInputChange}
                      value={formInputs.postalCode}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t('createMoovAccount.fields.email')}
                      onChange={onInputChange}
                      value={formInputs.emailOrPhone}
                      name='email'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t('createMoovAccount.fields.phone')}
                      onChange={onInputChange}
                      value={formInputs.emailOrPhone}
                      name='phone'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  {/* <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText='Date of birth - MM/DD/YYYY'
                      name='dateOfBirth'
                      onChange={onInputChange}
                      value={formInputs.dateOfBirth}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem> */}

                  {/* <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText='Last 4 of SSN'
                      onChange={onInputChange}
                      value={formInputs.last4OfSSN}
                      name='last4OfSSN'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem> */}
                  {/* <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText='Job title'
                      onChange={onInputChange}
                      value={formInputs.jobTitle}
                      name='jobTitle'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer> */}
                  {/* 
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='number'
                      labelText='Ownership percentage'
                      onChange={onInputChange}
                      value={formInputs.ownershipPercentage}
                      name='ownershipPercentage'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem> */}
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t('createMoovAccount.fields.website')}
                      onChange={onInputChange}
                      value={formInputs.website}
                      name='website'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t('createMoovAccount.fields.description')}
                      onChange={onInputChange}
                      value={formInputs.description}
                      name='description'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-org'>
                          {t('facilities.create.organizationsLabel')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-org'
                          value={organizationId}
                          onChange={onOrganizationIdChange}
                          name='organization_id'
                          className='full-width-elem'>
                          {organizations.map((obj, index) => (
                            <MenuItem value={obj && obj.id} key={index}>
                              {obj && obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                </GridContainer>
                {/* <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <div
                      style={{
                        display: 'flex',

                        gap: '5px',
                      }}>
                      <input
                        type='checkbox'
                        name='isOwner'
                        labelText=''
                        onChange={onInputChange}
                        value={formInputs.isOwner}
                      />
                      <label>Is Owner</label>
                    </div>
                  </GridItem>
                </GridContainer> */}

                {message && (
                  <GridContainer>
                    <GridItem xs={8} sm={8} md={6}>
                      <p style={{ color: 'red', padding: '10px 0' }}>
                        {message}
                      </p>
                    </GridItem>
                  </GridContainer>
                )}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button color='primary' type='submit'>
                      {t('createMoovAccount.buttons.create')}
                    </Button>
                    <Button
                      color='danger'
                      onClick={cancelfrm}
                      className='btn-cancel'
                      style={{ marginLeft: '5px' }}>
                      {t('createMoovAccount.buttons.cancel')}
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}
